import {auth} from '@/firebase';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error?.response?.data?.message ?? error);
  }
);
instance.interceptors.request.use(async req => {
  const token = await auth.currentUser?.getIdToken();

  if (token) {
    req.headers['Authorization'] = `Bearer ${token}`;
  }
  return req;
});

export const API = instance;
